var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 86 86"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#444",
  fillRule: "evenodd",
  d: "M75.45 12.596a2.687 2.687 0 0 0-3.907-3.692l-60.954 64.5a2.688 2.688 0 0 0 3.906 3.692l5.735-6.068a16.24 16.24 0 0 0 8.61 2.456h28.359c9.004 0 16.304-7.3 16.304-16.304V28.82c0-3.9-1.373-7.486-3.659-10.292zm-9.345 9.888L24.036 67a10.9 10.9 0 0 0 4.803 1.109H57.2c6.035 0 10.929-4.893 10.929-10.93V28.82c0-2.364-.748-4.548-2.023-6.336",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#444",
  d: "M28.84 12.516c-9.005 0-16.305 7.3-16.305 16.304v26.514a2.687 2.687 0 1 0 5.375 0V28.82c0-6.036 4.893-10.929 10.93-10.929h23.288a2.688 2.688 0 0 0 0-5.375z"
})));
export default SvgIcPlaceholder;